export const management = {
  routes: [
    {
      path: "/management/report-template",
      component: () => import("../management-library-report-template-view"),
    },

    {
      path: "/management/report-template/edit/:id",
      component: () => import("../management-library-report-template-form"),
    },
    {
      path: "/management/report-template/create",
      component: () => import("../management-library-report-template-form"),
    },
  ],
};

export const gdpr = {
  routes: [
    {
      path: "/gdpr/report",
      component: () => import("../gdpr-report-view"),
    },
  ],
};
export const kvkk = {
  routes: [
    {
      path: "/kvkk/report",
      component: () => import("../kvkk-report-view"),
    },
  ],
};
export const ddo = {
  routes: [
    {
      path: "/ddo/report",
      component: () => import("../ddo-report-view"),
    },
  ],
};
export const bgys = {
  routes: [
    {
      path: "/bgys/report",
      component: () => import("../bgys-report-view"),
    },
  ],
};
